import r from"../../shared-lib/braze-shared-lib.js";export function toggleLogging(){r.j.toggleLogging()}